var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRectangleDark = function SvgRectangleDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.126,
    height: 135.652,
    viewBox: "0 0 110.126 135.652"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_99",
    "data-name": "Union 99",
    d: "M54.856,135.525Q27.46,101.7,0,67.949C9.788,55.567,19.938,43.374,29.84,31.039,38.29,20.723,46.645,10.273,55.108,0,73.55,22.481,91.752,45.192,110.126,67.744c-2.536,3.865-5.959,7.334-8.76,11.1-15.484,18.9-30.808,37.955-46.334,56.812Z",
    fill: "#1c5868"
  })));
};

export { SvgRectangleDark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTAuMTI2IiBoZWlnaHQ9IjEzNS42NTIiIHZpZXdCb3g9IjAgMCAxMTAuMTI2IDEzNS42NTIiPgogIDxwYXRoIGlkPSJVbmlvbl85OSIgZGF0YS1uYW1lPSJVbmlvbiA5OSIgZD0iTTU0Ljg1NiwxMzUuNTI1UTI3LjQ2LDEwMS43LDAsNjcuOTQ5QzkuNzg4LDU1LjU2NywxOS45MzgsNDMuMzc0LDI5Ljg0LDMxLjAzOSwzOC4yOSwyMC43MjMsNDYuNjQ1LDEwLjI3Myw1NS4xMDgsMCw3My41NSwyMi40ODEsOTEuNzUyLDQ1LjE5MiwxMTAuMTI2LDY3Ljc0NGMtMi41MzYsMy44NjUtNS45NTksNy4zMzQtOC43NiwxMS4xLTE1LjQ4NCwxOC45LTMwLjgwOCwzNy45NTUtNDYuMzM0LDU2LjgxMloiIGZpbGw9IiMxYzU4NjgiLz4KPC9zdmc+Cg==";